export default __webpack_public_path__ + "static/media/melao_sapo.7e632859.jpg";